module.exports = __webpack_public_path__ + "bb.8d8c90d7c5b4476b6f9a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bb.svg
// module chunks = styles